import {ActionOnObject} from './ActionOnObject';

export class ObjectDeleteAction extends ActionOnObject {
  constructor(object) {
    super(object);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/actions/ObjectDeleteAction.ts